const cleanVatNumber = (raw: string = '') =>
  raw ? raw.replace(/[^a-z0-9]+/gi, '') : raw;

export default cleanVatNumber;
